/**
 * Blog Categories - Filtro AJAX
 */

export function initBlogCategories() {
  const categoriesSection = document.querySelector("#blog-categories");
  const categoryLinks = categoriesSection?.querySelectorAll(
    "a[data-category-id]"
  );
  const blogSection = document.querySelector("#blog-posts");
  const postsGrid = blogSection?.querySelector(".grid");
  const paginationContainer =
    blogSection?.querySelector(".blog-pagination")?.parentElement;

  if (!categoriesSection || !blogSection || !postsGrid) {
    return;
  }

  // Estado global da categoria ativa
  let activeCategory = null;

  // Expõe a função para outros módulos (busca e paginação)
  window.getActiveCategory = () => activeCategory;

  // Cria loading overlay
  const loadingOverlay = document.createElement("div");
  loadingOverlay.className =
    "absolute inset-0 bg-white/80 flex items-center justify-center z-10 hidden";
  loadingOverlay.innerHTML = `
    <div class="flex flex-col items-center gap-3">
      <div class="w-12 h-12 border-4 border-orange-500 border-t-transparent rounded-full animate-spin"></div>
      <span class="text-gray-600 font-medium">Carregando...</span>
    </div>
  `;

  const postsContainer = postsGrid.parentElement;
  postsContainer.style.position = "relative";
  postsContainer.appendChild(loadingOverlay);

  // Event delegation para as categorias
  categoryLinks.forEach((link) => {
    link.addEventListener("click", async (e) => {
      e.preventDefault();

      const categoryId = link.getAttribute("data-category-id");
      const categoryImage = link.querySelector(".category-circle");

      // Se clicar na mesma categoria, desativa o filtro
      if (activeCategory === categoryId) {
        activeCategory = null;
        categoryLinks.forEach((l) => {
          const img = l.querySelector(".category-circle");
          if (img) img.classList.remove("category-active");
        });
        loadPosts(null);
        return;
      }

      // Ativa a nova categoria
      activeCategory = categoryId;

      // Remove a classe de todas as categorias
      categoryLinks.forEach((l) => {
        const img = l.querySelector(".category-circle");
        if (img) img.classList.remove("category-active");
      });

      // Adiciona a classe na categoria ativa
      if (categoryImage) {
        categoryImage.classList.add("category-active");
      }

      // Carrega posts da categoria
      loadPosts(categoryId);
    });
  });

  async function loadPosts(categoryId, paged = 1) {
    loadingOverlay.classList.remove("hidden");

    // Scroll suave para o topo da seção
    blogSection.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });

    try {
      const response = await fetch(blogPagination.ajaxurl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          action: "blog_pagination",
          nonce: blogPagination.nonce,
          paged: paged,
          category_id: categoryId || "",
        }),
      });

      const data = await response.json();

      if (data.success) {
        postsGrid.innerHTML = data.posts_html;

        if (data.pagination_html) {
          paginationContainer.querySelector(".blog-pagination").innerHTML =
            data.pagination_html;
        } else {
          paginationContainer.querySelector(".blog-pagination").innerHTML = "";
        }

        // Atualiza a URL
        const newUrl = categoryId
          ? `?category=${categoryId}${paged > 1 ? "&paged=" + paged : ""}`
          : paged > 1
          ? "?paged=" + paged
          : window.location.pathname;
        window.history.pushState({ category: categoryId, paged }, "", newUrl);
      }
    } catch (error) {
      console.error("Erro ao carregar posts:", error);
    } finally {
      loadingOverlay.classList.add("hidden");
    }
  }

  // Expõe a função loadPosts para uso pela paginação
  window.blogCategoryLoadPosts = loadPosts;
}
